import CustomRegimes from ".";

export const customRegimeRoutes = [
  {
    path: "/customsRegimes",
    element: <CustomRegimes />,
  },
];
